var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oaid-checker"},[_c('div',{staticClass:"py-3"}),_vm._v(" "),_c('a',{staticClass:"button-primary blue-transparent",attrs:{"href":_vm.linktofinder}},[_c('span',{domProps:{"textContent":_vm._s(_vm.buttontext)}}),_vm._v(" "),_c('i',{staticClass:"fad fa-arrow-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }